export default function rand(min = 0, max = 1000000): number {
    return min + Math.floor(Math.random() * (max - min));
}
